import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import useStageIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getUseStage41_1Totals } from "../../../../../apis/Product/UseStageFlow41Api";

export const REFRESH_USE_STAGE_41_1_TOTALS = "refresh-use-stage-41-1-totals";

const UseStage41Icon = () => (
  <img src={useStageIcon} alt="Use Stage Icon" width={76} height={76} />
);

const UseStage41Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalFlow41_1, setTotalFlow41_1] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getUseStage41_1Totals({
        productId,
        setTotals: setTotalFlow41_1,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    window.addEventListener(REFRESH_USE_STAGE_41_1_TOTALS, handleRefresh);
    return () => {
      window.removeEventListener(REFRESH_USE_STAGE_41_1_TOTALS, handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`use-stage-41-category ${className || ""}`}
      leftBoxProps={{
        icon: <UseStage41Icon />,
        title: t("USE_STAGE") || "Use Stage",
        description:
          t("USE_STAGE_DESC") ||
          "Describe how the product is used. Select the most suitable materials or state the material consumption, electricity and water usage, and surplus materials.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_41_1") || "Total for Flow 41.1",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalFlow41_1?.impact_totals || null,
        lastUpdated: totalFlow41_1?.updated_at
          ? formatDate(totalFlow41_1?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default UseStage41Header;
